<template>
    <div>
        <!-- Dialog de anúncio -->
        <v-dialog v-model="adsDialog" :fullscreen="$vuetify.breakpoint.xs" max-width="450"
            transition="dialog-bottom-transition" persistent>
            <v-card v-if="showAd && adsDialog" class="ad-card">
                <Video v-if="anuncio.youtube_src" :autoplay="true" :repeat="true" :href="anuncio.link" target="_blank"
                    :src="anuncio.youtube_src" class="ad-media" />
                <v-img v-else :src="anuncio.img_src" class="ad-media" />

                <v-divider />
                <v-card-actions class="ad-actions">
                    <a @click="onAdClick(anuncio)" target="_blank" class="ad-link">
                        {{ anuncio.titulo }}
                    </a>
                    <v-spacer />
                    <v-btn v-if="showCloseButton" color="error" @click="closeAd" icon>
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-btn v-else color="error" icon>
                        <v-progress-circular :size="30" color="white" indeterminate />
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Banner de anúncio -->
        <AnuncioBanner v-if="showBanner && showAd && anuncio.id !== null" />
    </div>
</template>

<script>
import { mapState } from 'vuex';
import Video from '../../views/components/Video';
import AnuncioBanner from '../../views/components/AnuncioBanner';

export default {
    name: 'AdComponent',
    components: {
        Video,
        AnuncioBanner
    },
    props: {
        // Se o anúncio deve ser exibido
        active: {
            type: Boolean,
            default: true
        },
        // Tempo mínimo para exibir o botão de fechar (em milissegundos)
        closeDelay: {
            type: Number,
            default: 5000
        }
    },
    data() {
        return {
            adsDialog: true,
            showCloseButton: false,
            closeTimer: null
        };
    },
    computed: {
        ...mapState('app', ['user', 'anuncio', 'permiteAcessoGratuito']),

        // Determina se o anúncio deve ser exibido
        showAd() {
            return this.active && this.anuncio && this.anuncio.id !== null;
        },

        // Determina se o banner deve ser exibido
        showBanner() {
            return this.showCloseButton;
        }
    },
    watch: {
        // Quando o anúncio é exibido, inicia o timer para mostrar o botão de fechar
        showAd: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.startCloseTimer();
                } else {
                    this.clearCloseTimer();
                }
            }
        }
    },
    methods: {
        // Inicia o timer para exibir o botão de fechar
        startCloseTimer() {
            this.clearCloseTimer();
            this.showCloseButton = false;

            this.closeTimer = setTimeout(() => {
                this.showCloseButton = true;
            }, this.closeDelay);
        },

        // Limpa o timer
        clearCloseTimer() {
            if (this.closeTimer) {
                clearTimeout(this.closeTimer);
                this.closeTimer = null;
            }
        },

        // Fecha o anúncio
        closeAd() {
            this.adsDialog = false;
            this.$emit('ad-closed');
        },

        // Manipula o clique no anúncio
        onAdClick(anuncio) {
            this.$emit('ad-clicked', anuncio);

            // Registra o clique no analytics (se disponível)
            if (this.$gtag) {
                this.$gtag.event('ad_click', {
                    event_category: 'ad_interaction',
                    event_label: `ad_${anuncio.id}`,
                    value: 1
                });
            }
        }
    },
    beforeDestroy() {
        this.clearCloseTimer();
    }
};
</script>

<style scoped>
.ad-card {
    min-width: 450px;
    max-width: 100%;
    max-height: 500px;
    overflow: auto;
    overflow-y: hidden;
    z-index: 999;
}

.ad-media {
    height: 400px;
}

.ad-actions {
    padding: 8px 16px;
}

.ad-link {
    text-decoration: none;
    color: inherit;
    cursor: pointer;
}

.ad-link:hover {
    text-decoration: underline;
}

/* Responsividade */
@media (max-width: 600px) {
    .ad-card {
        min-width: unset;
        width: 100%;
    }

    .ad-media {
        height: 300px;
    }
}
</style>